import { render, staticRenderFns, recyclableRender, components } from "./tn-notice-bar.vue?vue&type=template&id=7b115e5f&scoped=true&"
var renderjs
import script from "./tn-notice-bar.vue?vue&type=script&lang=js&"
export * from "./tn-notice-bar.vue?vue&type=script&lang=js&"
import style0 from "./tn-notice-bar.vue?vue&type=style&index=0&id=7b115e5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../软件/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b115e5f",
  null,
  false,
  components,
  renderjs
)

export default component.exports